<template>
  <div>
    <div class="progress-bar-title" id="progressbarheader" data-test="progress-bar">
      Step {{ props.activeStep }} of {{ props.totalSteps }}
    </div>

    <div class="progress">
      <div
        class="progress-bar"
        role="progressbar"
        aria-labelledby="progressbarheader"
        :style="'width: ' + getWidth()"
      ></div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  activeStep: Number,
  totalSteps: Number
})

function getWidth() {
  return (props.activeStep / props.totalSteps) * 100 + "%";
}
</script>

<style scoped>
.progress-bar-title {
  font-size: 23px;
  font-weight: bold;
  margin-bottom: 10px;
}
</style>
